import { useState,useEffect} from "react";
import dayjs from "dayjs";
import JDate from "jalali-date";
import React from "react";

// import {$postWithResult} from "../../../plugins/axios"
import Container from "./index-css";
const Index = ({ data }) => {
    ;
    const [showMore1, setShowMore1] = useState(false)
    const [showMore2, setShowMore2] = useState(false)
    const [showMore3, setShowMore3] = useState(false)
    const [coverage, setCoverage] = useState({
        data: [
            {
                firehome_coverage_calculat_id: "2",
                firehome_coverage_desc:
                    "جبران خساراتی که مستقیما در اثر وقوع زلزله یا اتشفشان و یا اتش سوزی ناشی از حادثه مزبور باشد",
                firehome_coverage_extrafield: "0",
                firehome_coverage_id: "1",
                firehome_coverage_name: "زلزله و اتشفشان",
            },
        ],
    })
    useEffect(() => {
        // getCoverage()
    }, [])
    // async function getCoverage() {
    //    const result = await $postWithResult(
    //       `firehome?command=get_firehome_coverage`
    //    )
    //    setCoverage(result)
    // }

    var extra = []
    try {
        // extra = JSON.parse(data.data[0].request_firehome_exterafield)
        extra = JSON.parse(data.data[0].request_detail_json)

    } catch (e) {
        console.error(e)
        extra = []
    }
    // var final = []
    // var flag2 = ""
    // for (var i = 0; i < coverage.data.length; i++) {
    //    flag2 = "false"
    //    // for (var j = 0; j < data.covarage.length; j++) {
    //    for (var j = 0; j < extra.ms_coverage_detail.length; j++) {
    //       if (
    //           extra.ms_coverage_detail[j].id ===
    //           coverage.data[i].firehome_coverage_id
    //       ) {
    //          flag2 = "true"
    //       }
    //    }
    //    if (flag2 === "false") {
    //       final.push({
    //          name: coverage.data[i].firehome_coverage_name,
    //          status: "خیر",
    //       })
    //    }else {
    //          if (
    //              coverage.data[i].firehome_coverage_extrafield === "1"
    //          ) {
    //              let objIndex = extra.ms_coverage_detail.findIndex((obj => obj.id == coverage.data[i].firehome_coverage_id));
    //              let msPricew = extra.ms_coverage_detail[objIndex].value  +  " ریال ";
    //              final.push({
    //                name: coverage.data[i].firehome_coverage_name,
    //                id: coverage.data[i].firehome_coverage_id,
    //                status: formatPrice( msPricew
    //                    // `${
    //                    //     (extra.filter(function (t) {
    //                    //         return (
    //                    //             t.id ===
    //                    //             parseInt(coverage.data[i].firehome_coverage_id)
    //                    //         )
    //                    //     })[0])?
    //                    //     extra.filter(function (t) {
    //                    //        return (
    //                    //            t.id ===
    //                    //            parseInt(coverage.data[i].firehome_coverage_id)
    //                    //        )
    //                    //     })[0].value:0
    //                    // } ریال`
    //
    //                ),
    //             })
    //          } else {
    //             final.push({
    //                name: coverage.data[i].firehome_coverage_name,
    //                status: "بله",
    //             })
    //          }
    //
    //    }
    //
    // }


    function formatPrice(value) {
        return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    }

    var arrPrice = []
    try {
        arrPrice = JSON.parse(data.data[0].jsonpricing_text)
        if (arrPrice.instalment_conditions) {
            var cash = arrPrice.instalment_conditions.filter(
                (c) => c.instalment_conditions_mode_id === "0"
            )
            var check = arrPrice.instalment_conditions.filter(
                (c) => (c.instalment_conditions_mode_id === "1" || c.instalment_conditions_mode_id === "3")
            )
        }
    } catch (e) {}
    var active_star =
        parseInt(arrPrice.company_customer_satisfaction) +
        parseInt(arrPrice.company_levelof_prosperity) +
        parseInt(arrPrice.company_timeanswer_complaints)

    active_star = Math.ceil(active_star / 3 / 2)
    var deactive_star = 5 - active_star
    const Stars = () => {
        var stars = []
        for (var i = 0; i < active_star; i++) {
            stars.push(<img src='/imagess/star.png' key={i + deactive_star} alt="star icon" />)
        }
        return <>{stars}</>
    }

    const Stars_ = () => {
        var dstars = []
        for (var i = 0; i < deactive_star; i++) {
            dstars.push(<img src='/imagess/star_.png' key={i} alt="star icon"/>)
        }
        return <>{dstars}</>
    }

    const handleClick = (id) => {
        if (id === 1) {
            setShowMore1(!showMore1)
        } else if (id === 2) {
            setShowMore2(!showMore2)
        } else if (id === 3) {
            setShowMore3(!showMore3)
        }
    }

    // *******************component************component*******************component*****************component*************

    const Text = (props) => {
        return (
            <Container>
                <div className="main-textt">
                    <div className="text-title">{props.title} {props.detail == undefined ? "" : ":"}</div>
                    <div className="text-detail">{props.detail === "undefined" ? "" : props.detail}</div>
                </div>
            </Container>
        );
    };

    const Linetitle = (props) => {
        return (
            <Container>
                <div className="main-line">
                    <div style={{ width: "100%" }} className="line">
                        <div style={{ width: props.w }} className="line-text">
                            {props.name}
                        </div>
                    </div>
                </div>
            </Container>
        );
    };
    return (
        <Container>
            <div className="main-map-detail">
                <div className="title">
                    خلاصه سفارش بیـــمه
                    <span
                        style={{
                            color: "#1ad4a3",
                            marginRight: "5px",
                            display: "flex",
                        }}
                    >
            آتش سوزی مسکونی
              </span>
                </div>
                <Linetitle name="اطلاعات ملک" />
                <div  className="map-detail-divv">
                    <Text title="نوع ملک" detail={extra.firehome_kind_name} />
                    <Text title="نوع سازه" detail={extra.firehome_typeofcons_name} />
                    <Text title="ارزش لوازم منزل" detail={`${formatPrice(
                        extra.firehome_cost_furniture
                    )}ریال`} />
                    <Text
                        title=" متراژ واحد یا متراژ هرواحد"
                        detail={`${extra.firehome_area}متر مربع`}
                    />
                    <Text title="عمر بنا" detail={extra.firehome_buildinglife_id + " سال "} />

                    <Text
                        title="هزینه ساخت هر متر مربع"
                        detail={`${formatPrice(extra.firehome_costcons_name)}`}
                    />

                </div>



                <Linetitle name="پوشش های اضافی" />
                <div className="map-detail-divv">
                    {extra.ms_coverage_detail.map((c) =>
                        <Text
                            title={c.name}
                            detail={c.value}
                        />
                    )}


                </div>

                <Linetitle name="اطلاعات بیمه" />
                <div className="map-detail-divv">
                    <Text title="نام بیمه" detail={arrPrice.company_name} />
                    <Text title="امتیاز بیمه" detail={arrPrice.company_levelof_prosperity} />
                    <Text
                        title="مبلغ بیمه"
                        detail={`${formatPrice(arrPrice.price)} ریال`}
                    />
                    <Text
                        title="درصد تخفیف مدیریتی"
                        detail={
                            arrPrice.managdiscount_amount
                                ? `${arrPrice.managdiscount_amount} درصد`
                                : "ندارد"
                        }
                    />


                    <Text
                        title="امکان خرید اقساطی"
                        detail={arrPrice.instalment_conditions ? "بله" : "خیر"}
                    />
                    <>
                        {arrPrice.instalment_conditions && arrPrice.instalment_conditions.map((data) => (
                            <Text
                                title={data.instalment_conditions_desc}
                                detail={data.instalment_conditions_amount}
                            />
                        ))}
                    </>
                </div>
            </div>
        </Container>
    );
};

export default Index;
